import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import TradiePro from '../components/TradiePro';

const GRID_BG = {
  backgroundImage: 'linear-gradient(rgba(0,0,0,0.022) 1px, transparent 1px), linear-gradient(90deg, rgba(0,0,0,0.022) 1px, transparent 1px)',
  backgroundSize: '44px 44px',
};

const TradieProPage = () => (
  <div style={{ background: '#ECEAE3', minHeight: '100vh', ...GRID_BG }}>
    <Header />

    <section style={{ maxWidth: 1100, margin: '0 auto', padding: '72px 40px 0', textAlign: 'center' }}>
      <div style={{ display: 'inline-flex', alignItems: 'center', gap: 10, background: '#fff', borderRadius: 999, padding: '9px 20px', fontSize: 14, fontWeight: 800, boxShadow: '0 1px 3px rgba(0,0,0,0.05)', marginBottom: 24 }}>
        <span style={{ fontSize: 18 }}>⚡</span>
        TradiePro
        <span style={{ color: '#8A857A', fontWeight: 600 }}>· Trades & Home Services</span>
      </div>
      <h1 style={{ fontSize: 'clamp(2.4rem, 5vw, 3.6rem)', fontWeight: 800, letterSpacing: '-0.03em', margin: 0, lineHeight: 1.04, color: '#1A1A18' }}>
        From inbox to done —<br />
        <span style={{ borderBottom: '6px solid #C0492A', paddingBottom: 2 }}>automatically.</span>
      </h1>
      <p style={{ fontSize: 20, lineHeight: 1.55, color: '#5A564D', maxWidth: 640, margin: '22px auto 0' }}>
        Your client sends an email. Our automation reads it, creates the work order, and drops it on your dashboard. Mark it done — the client gets notified. No missed jobs.{' '}
        <strong style={{ color: '#1A1A18' }}>In TradiePro, we've got you.</strong>
      </p>
      <div style={{ display: 'flex', gap: 14, justifyContent: 'center', marginTop: 32 }}>
        <Link to="/#booking" style={{ display: 'inline-block', background: '#C0492A', color: '#fff', fontSize: 16, fontWeight: 700, padding: '15px 28px', borderRadius: 12, textDecoration: 'none' }}>
          Book a call →
        </Link>
      </div>
    </section>

    <TradiePro />
    <Footer />
  </div>
);

export default TradieProPage;
